import axios, { AxiosInstance } from 'axios';
import { passkeyKey } from '../state/storageKey';
import { getUserToken } from '../state';
import {
  BtcCreateSendBtcPsbt,
  BtcSignPsbt,
  CustomTokenParams,
  CustonTokenType,
  SolSendTx,
  SwapResult,
  TokenType,
} from './type';
import { IChainId } from '../state/type';

let globalEndpoints: string[] = [];
let globalTmaUserId = '';
let globalTmaUserKey = '';
export const successCode = 8000;
export const api: {
  index: AxiosInstance | undefined;
  bot: AxiosInstance | undefined;
  auth: AxiosInstance | undefined;
  tomo: AxiosInstance | undefined;
  pk: AxiosInstance | undefined;
  sun: AxiosInstance | undefined;
  init: (endpoints: [string], tmaid: string, tmakey: string) => void;
} = {
  index: undefined,
  bot: undefined,
  tomo: undefined,
  auth: undefined,
  pk: undefined,
  sun: undefined,
  init(endpoints: [string], tmaid, tmakey) {
    const endPoints = {
      bot: endpoints[0] + 'moon/',
      auth: endpoints[0] + 'wind/',
      pk: endpoints[0] + 'rain/',
      sun: endpoints[0] + 'sun/',
      tomo: endpoints[0] + 'sky/api/',
    };
    this.bot = axios.create({ baseURL: endPoints.bot });
    this.auth = axios.create({ baseURL: endPoints.auth });
    this.pk = axios.create({ baseURL: endPoints.pk });
    this.sun = axios.create({ baseURL: endPoints.sun });
    this.tomo = axios.create({
      baseURL: endPoints.tomo,
    });
    globalEndpoints = endpoints;
    globalTmaUserId = tmaid;
    globalTmaUserKey = tmakey;
    [this.index, this.tomo, this.auth, this.bot, this.pk, this.sun].forEach(
      (apiItem: AxiosInstance | undefined) => {
        if (!apiItem) return;
        apiItem.interceptors.request.use(
          config => {
            // if (config.baseURL != endpoints[0] + 'bot-server/') {
            Object.defineProperty(config.headers, 'X-TOMO-TMA-USERID', {
              value: tmaid,
              writable: true,
              enumerable: true,
              configurable: true,
            });

            Object.defineProperty(config.headers, 'X-TOMO-TMA-KEY', {
              value: tmakey,
              writable: true,
              enumerable: true,
              configurable: true,
            });
            // }
            const passKey = getPassKey();

            if (passKey && config.baseURL === endPoints.pk) {
              config.headers.mfa = passKey;
            }
            if (
              passKey &&
              config.baseURL === endPoints.tomo &&
              config.url != 'token/swapList'
            ) {
              config.headers.mfa = passKey;
            }
            const token = getUserToken();

            if (token && config.url != 'token/swapList') {
              config.headers.Authorization = `Bearer ${token}`;
            }

            return config;
          },
          error => {
            console.log('null', error);

            if (error?.response?.status === 401) {
              return Promise.reject(error);
            }
            return null;
          }
        );
      }
    );
  },
};

export class GatewayError extends Error {
  code: number;

  constructor(message: string, code: number = 0) {
    super(message);
    this.name = this.constructor.name;
    this.code = code;
  }
}
export const pkCallback = async (callback: () => Promise<any>) => {
  try {
    const res = await callback();
    if (!res || !res.data) {
      throw new GatewayError('Failed to get data', 500);
    }
    return res.data;
  } catch (err) {
    console.error(err);
    if (err?.response?.data?.message) {
      throw new GatewayError(
        err?.response?.data?.message,
        err?.response?.data?.code
      );
    }
    throw err;
  }
};
export const authCallback = async (callback: () => Promise<any>) => {
  try {
    const res = await callback();
    if (!res || !res.data) {
      throw new GatewayError('Failed to get data', 500);
    }
    return res.data;
  } catch (err) {
    console.error(err);
    if (err?.response?.data?.message) {
      throw new GatewayError(
        err?.response?.data?.message,
        err?.response?.data?.code
      );
    }
    throw err;
  }
};
export const sunCallback = async (callback: () => Promise<any>) => {
  try {
    const res = await callback();
    if (!res || !res.data) {
      throw new GatewayError('Failed to get data', 500);
    }
    return res.data;
  } catch (err) {
    console.error(err);
    if (err?.response?.data?.message) {
      throw new GatewayError(
        err?.response?.data?.message,
        err?.response?.data?.code
      );
    }
    throw err;
  }
};
export const tomoCallback = async (callback: () => Promise<any>) => {
  const res = await callback();
  if (res.code != 10000) {
    throw new GatewayError(res.message, res.code);
  }
  return res;
};
export const getPassKey = () => {
  try {
    const token = localStorage.getItem(passkeyKey);
    return token ?? '';
  } catch (e) {
    return null;
  }
};

export const loginApi = async (initData: string) => {
  try {
    const res = await api.bot?.get(`login?${initData}`);
    return res?.data;
  } catch (err) {
    console.error(err);
    if (err.response.status == 401) {
      throw new GatewayError(err.response.data, 401);
    }
    throw err;
  }
};

export const checkLoginByCodeApi = async (session_code: string) => {
  try {
    const res = await api.bot?.get(`session/token`, {
      headers: {
        'session-code': session_code,
      },
    });
    return res?.data;
  } catch (err) {
    console.error(err);
    if (err.response.status == 401) {
      throw new GatewayError('Not logged in', 401);
    }
    throw err;
  }
};

export const pkRegApi = async (device_no: string) => {
  return await pkCallback(async () => {
    return await api.pk?.post('v2/reg/' + device_no, {});
  });
};

export const pkCreateApi = async (data: {
  device_no: string;
  pubkey: string;
}) => {
  return await authCallback(async () => {
    return await api.auth?.post('v2/passkey/create/', data);
  });
};
export const pkCheckApi = async (device_no: string) => {
  return await authCallback(async () => {
    return await api.auth?.get('v2/passkey/check/' + device_no);
  });
};

export const pkSignApi = async (
  data: {
    message: string;
    device_no?: string;
  },
  headers: any = {}
) => {
  return await pkCallback(async () => {
    return await api.pk?.post('v2/sign', data, { headers });
  });
};

export const pkValidateApi = async (
  data: {
    device_no?: string;
    message: string;
    sig: string;
  },
  headers: any = {}
) => {
  return await authCallback(async () => {
    return await api.auth?.post('v2/passkey/validate/', data, { headers });
  });
};

export const btcSignPsbtAndPush = async (params: BtcSignPsbt) => {
  return await tomoCallback(async () => {
    const { data } = await api.tomo?.post(
      `socialLogin/projectWallet/bitcoin/signPsbtAndPush`,
      params
    );
    return data;
  });
};

export const sendEvmTransactionApi = async (
  mfa: string,
  data: {
    transaction: { [key: string]: any };
    chainId: number;
    rpc: string;
  }
) => {
  return await tomoCallback(async () => {
    const token = getUserToken();

    const res = await api.tomo?.post(
      'socialLogin/projectWallet/ethereum/sendTransaction',
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          MFA: mfa,
        },
      }
    );
    return res.data;
  });
};

export const signEvmTransactionApi = async (
  mfa: string,
  data: {
    transaction: { [key: string]: any };
    chainId: number;
    rpc: string;
  }
) => {
  return await tomoCallback(async () => {
    const token = getUserToken();

    const res = await api.tomo?.post(
      'socialLogin/projectWallet/ethereum/signTransaction',
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          MFA: mfa,
        },
      }
    );
    return res.data;
  });
};

export const tonSignMessage = async (
  mfa: string,
  data: { signingMessageBoc: string }
) => {
  return await tomoCallback(async () => {
    const token = getUserToken();

    const res = await api.tomo?.post(
      '/socialLogin/projectWallet/ton/signTransaction',
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          MFA: mfa,
        },
      }
    );
    return res.data;
  });
};

export const solSignRawTransaction = async (params: SolSendTx) => {
  return await tomoCallback(async () => {
    const { data } = await api.tomo?.post(
      `socialLogin/projectWallet/solana/signRawTransaction`,
      params
    );
    return data;
  });
};

// send BTC
export const btcCreateSendBtcPsbt = async (params: BtcCreateSendBtcPsbt) => {
  return await tomoCallback(async () => {
    const { data } = await api.tomo?.post(
      `socialLogin/projectWallet/bitcoin/createSendBitcoinPsbt`,
      params
    );
    return data;
  });
};

export const btcSignMessage = async (params: any) => {
  return await tomoCallback(async () => {
    const { data } = await api.tomo?.post(
      `socialLogin/projectWallet/bitcoin/signMessage`,
      params
    );
    return data;
  });
};

export const btcSignPsbt = async (params: BtcSignPsbt) => {
  return await tomoCallback(async () => {
    const { data } = await api.tomo?.post(
      `socialLogin/projectWallet/bitcoin/signPsbt`,
      params
    );
    return data;
  });
};

export const decodeInfoByHex = async (params: any) => {
  return await tomoCallback(async () => {
    const { data } = await api.tomo?.post(
      `socialLogin/projectWallet/bitcoin/decode`,
      params
    );
    return data;
  });
};

export const v2PkRegApi = async (device_no: string) => {
  return await pkCallback(async () => {
    return await api.pk?.post('v2/reg/' + device_no, {});
  });
};

export const v2PkSignApi = async (data: {
  message: string;
  device_no: string;
}) => {
  return await pkCallback(async () => {
    return await api.pk?.post('v2/sign', data);
  });
};

export const v2PkValidateApi = async (data: {
  device_no: string;
  message: string;
  sig: string;
}) => {
  return await authCallback(async () => {
    return await api.auth?.post('v2/passkey/validate/', data);
  });
};

export const v2PkCreateApi = async (data: {
  device_no: string;
  pubkey: string;
}) => {
  return await authCallback(async () => {
    return await api.auth?.post('v2/passkey/create/', data);
  });
};

export const v2PkCheckApi = async (device_no: string) => {
  return await authCallback(async () => {
    return await api.auth?.get('v2/passkey/check/' + device_no);
  });
};

export const checkPaymentPasswd = async () => {
  return await authCallback(async () => {
    return await api.auth?.get('v1/payment/passwd/check', {});
  });
};
export const setPaymentPasswd = async (data: { passwd: string }) => {
  return await authCallback(async () => {
    return await api.auth?.post('v1/payment/passwd/set', data);
  });
};
export const changePaymentPasswd = async (data: {
  old_passwd: string;
  new_passwd: string;
}) => {
  return await authCallback(async () => {
    return await api.auth?.post('v1/payment/passwd/change', data);
  });
};
export const validatePaymentPasswd = async (data: { passwd: string }) => {
  return await authCallback(async () => {
    return await api.auth?.post('v1/payment/passwd/validate', data);
  });
};
export const bindEmailCodeVerify = async (params: {
  email: string;
  code: string;
}) => {
  return await tomoCallback(async () => {
    const { data } = await api.tomo?.post(
      `socialLogin/projectUser/bindEmailCodeVerify`,
      params
    );
    return data;
  });
};
export const bindEmailCodeSend = async (email: string) => {
  return await tomoCallback(async () => {
    const { data } = await api.tomo?.get(
      `socialLogin/projectUser/bindEmailCode?email=${email}`
    );
    return data;
  });
};

export const getSwapAllTokens = async (): Promise<any> => {
  return await tomoCallback(async () => {
    const ret = await api.tomo?.get(`socialLogin/teleGram/wallet/tokens`, {});
    return ret.data;
  });
};

export const getSwapAllTokensSearch = async (
  queryParameters: {
    content: string;
    chain?: string;
  },
  config: { url: string; tmaid: string; tmakey: string }
): Promise<any> => {
  const ret = await axios.get(`${config.url}wallet/tokens/search`, {
    params: queryParameters,
    headers: {
      'X-TOMO-TMA-USERID': config.tmaid,
      'X-TOMO-TMA-KEY': config.tmakey,
    },
  });
  return ret.data;
};

export const buildSwapTxApi = async (params: {
  fromChainid: number;
  toChainid: number;
  fromAddress: string;
  toAddress: string;
  amount: string;
  slippage: number;
  fromWalletAddress: string;
  toWalletAddress: string;
}): Promise<SwapResult> => {
  const res = await sunCallback(async () => {
    return await api.sun?.get(`v1/buildTx`, {
      params,
    });
  });
  return res.data;
};

export const getSystemTokens = async (params: {
  evm_address: string;
  solana_address: string;
}): Promise<TokenType[]> => {
  const res = await authCallback(async () => {
    return await api.auth?.get(`v1/token/balance`, { params });
  });
  return res.data;
};

export const v1AddAssetApi = async (data: CustomTokenParams) => {
  return await authCallback(async () => {
    return await api.auth?.post('v1/asset/add', data);
  });
};

export const v1AllAssetApi = async (params: {
  page: number;
  pageSize: number;
  chain_ids?: number[];
}): Promise<CustonTokenType[]> => {
  const res = await authCallback(async () => {
    return await api.auth?.get('v1/asset/all', { params });
  });
  return res.data;
};

export const mfaAuthVerificationApi = async (data: any) => {
  return await tomoCallback(async () => {
    const res = await api.tomo?.post('socialLogin/mfa/auth/verification', data);
    return res.data;
  });
};

export const getSwapAllTokensV3 = async (params: {
  chain: string;
}): Promise<{
  result: any[];
}> => {
  // if (globalEndpoints.length == 0) {
  //   return {
  //     result: [],
  //   };
  // }
  return await tomoCallback(async () => {
    const token = getUserToken();

    const ret = await api.tomo?.get(`token/swapList`, {
      params,
    });
    return ret.data;
  });
};
export const sendBindEmailCodeApi = async (params: { email: string }) => {
  return await tomoCallback(async () => {
    const ret = await api.tomo?.get(`socialLogin/teleGram/bindEmailCode`, {
      params,
    });
    return ret.data;
  });
};

export const verifyBindEmailCodeApi = async (data: {
  email: string;
  code: string;
  tradePassword: string;
}) => {
  return await tomoCallback(async () => {
    const res = await api.tomo?.post(
      'socialLogin/teleGram/bindEmailCodeVerify',
      data
    );
    return res.data;
  });
};

export const getTelegramUserInfoApi = async () => {
  return await tomoCallback(async () => {
    const res = await api.tomo?.get(`socialLogin/teleGram/userInfo`);
    return res.data;
  });
};

export const getConfigChainsAll = async (): Promise<{
  chain_id_name: {
    [key in IChainId]?: string;
  };
}> => {
  const { data } = await axios.get(
    `https://common-service.mobus.workers.dev/chain/all`
  );
  return data.result;
};
